import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { BankAccount } from 'src/features/billingEntityBankAccounts/utils/types';

const RESOURCE = '/customers/billing-entity-bank-account/:id/';

type QueryFnType = typeof queryFn;

interface DTO {
    id: string;
}
const queryFn = ({ id }: DTO): Promise<BankAccount> => {
    return axios.get(formatResourcePath(RESOURCE, { id }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetBillingEntityBankAccount, RESOURCE as BILLING_ENTITY_BANK_ACCOUNT_RESOURCE };
